import AuthGuard from '../components/AuthGuard';
import InnerLayout from '../components/InnerLayout';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { api } from '../lib/api';
import { useNavigate } from 'react-router-dom';

export default function SecurityPage() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [oldPwd, setOldPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => { api.get('/me').then(({ data: u }) => setPhone(u?.phone ?? '')).catch(() => { }); }, []);

  async function submit() {
    if (!oldPwd) { toast.error('请输入原密码'); return; }
    if (!newPwd || newPwd.length < 6) { toast.error('新密码至少6位'); return; }
    if (newPwd !== confirmPwd) { toast.error('两次密码不一致'); return; }
    setSubmitting(true);
    try {
      await api.post('/security/password', { old: oldPwd, password: newPwd });
      toast.success('密码修改成功');
      setOldPwd(''); setNewPwd(''); setConfirmPwd('');
    } catch (err: any) {
      toast.error(err?.response?.data?.message ?? '修改失败');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="max-w-md mx-auto min-h-screen bg-[#8b0000]">
      <AuthGuard />

      {/* Header */}
      <div className="relative pt-4 px-4">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 left-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/80 text-black"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <div className="flex flex-col items-center gap-3 justify-center relative text-white">
          <h4>账号安全</h4>
        </div>
      </div>

      <div className="mx-auto max-w-md px-4 space-y-4">
        <div className="mt-5 space-y-3">
          <div className="rounded-xl bg-white p-4 shadow border-[1px] border-[#e5e7eb]">
            <div className="mb-1 text-xs text-gray-500">手机号</div>
            <div className="w-full rounded-md border border-gray-300 bg-[#f8f8f8] p-3 text-xs text-gray-600">{phone || '—'}</div>

            <div className="mt-4 mb-1 text-xs">原密码</div>
            <input type="password" className="w-full rounded-md border border-gray-300 bg-[#f8f8f8] p-3 text-xs" placeholder="请输入原密码" value={oldPwd} onChange={e => setOldPwd(e.target.value)} />

            <div className="mt-3 mb-1 text-xs">新密码</div>
            <input type="password" className="w-full rounded-md border border-gray-300 bg-[#f8f8f8] p-3 text-xs" placeholder="请输入新密码（至少6位）" value={newPwd} onChange={e => setNewPwd(e.target.value)} />

            <div className="mt-3 mb-1 text-xs">确认新密码</div>
            <input type="password" className="w-full rounded-md border border-gray-300 bg-[#f8f8f8] p-3 text-xs" placeholder="请再次输入新密码" value={confirmPwd} onChange={e => setConfirmPwd(e.target.value)} />

            <button className="mt-4 w-full bg-[#c4161c] py-2 text-white rounded-md disabled:bg-gray-400" onClick={submit} disabled={submitting}>
              {submitting ? '提交中...' : '修改密码'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}